import React from 'react';

import styled from 'styled-components';

import theme from 'styles/token/color';
import { typography } from 'styles/token/typography';

/**
 * @param {Object} subItem 다중 계층 메뉴의 서브 아이템 정보
 * @param {Array<Object>} sections 메뉴 하위 링크 배열
 * @param {number} openDepthIndex 현재 활성화된 메뉴 인덱스 (hover/active 관리)
 * @param {function} setOpenDepthIndex openDepthIndex 상태를 업데이트하는 함수
 * @returns
 */
const LeftSubMenu = ({
  subItem = {},
  items = [],
  openDepthIndex = null,
  setOpenDepthIndex = () => {},
}) => {
  return (
    <LeftSubMenuWrapper>
      {subItem?.label && <LeftSubMenuLabel>{subItem.label}</LeftSubMenuLabel>}

      {items.length > 0 && (
        <LeftSubMenuTitleList
          className={subItem?.label ? 'cursor' : ''}
          $isCursor={!!subItem?.label || items.length > 1}
        >
          {items.map((item, i) => (
            <LeftSubMenuTitle
              key={`left-menu-${i}`}
              onMouseEnter={() => setOpenDepthIndex(i)}
              onClick={() => setOpenDepthIndex(i)}
              className={openDepthIndex === i ? 'active' : ''}
              $isCursor={!!subItem?.label || items.length > 1}
            >
              {item.leftTitle || item.title}
            </LeftSubMenuTitle>
          ))}
        </LeftSubMenuTitleList>
      )}
    </LeftSubMenuWrapper>
  );
};

export default LeftSubMenu;

const LeftSubMenuWrapper = styled.div``;

const LeftSubMenuLabel = styled.label`
  display: flex;
  margin-bottom: 12px;
  color: ${({ theme }) => theme.color.gray500};
  ${typography.labelSmall}
`;
const LeftSubMenuTitleList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const LeftSubMenuTitle = styled.p`
  color: ${theme.color.white};
  ${typography.titleSmall}
  font-weight: 300;
  width: max-content;
  padding: 6px 20px;
  cursor: ${({ $isCursor }) => ($isCursor ? 'pointer' : 'default')};
  border-radius: 20px;
  transition: background-color 0.2s ease-in-out;

  &.active {  
    background: rgba(60, 60, 71, 0.4);   
  }
`;
